/*
  Hero trust ribbon.

  The section renders the trust items once. This clones that set until the track
  is at least twice as wide as its container, which lets a -50% translate loop
  seamlessly at any screen width. Duration is derived from the distance so the
  ribbon travels at a constant speed regardless of how much copy it carries.

  Without JS the items simply sit in a static row.
*/
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MAX_CLONES = 40; // guards against a zero-width measurement looping forever

  function build(root) {
    var track = root.querySelector('[data-pl-track]');
    if (!track) return;

    // Clear previous clones BEFORE capturing the originals. Reading the
    // children first would treat the last run's clones as originals, so each
    // resize or font-load rebuild would multiply the track instead of
    // reproducing it.
    track.classList.remove('pl-trust__track--running');
    Array.prototype.slice.call(track.children).forEach(function (child) {
      if (child.dataset.plClone === 'true') track.removeChild(child);
    });

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    if (REDUCED) return;

    var viewport = root.querySelector('.pl-trust__viewport');
    var containerWidth = (viewport || root).getBoundingClientRect().width;
    var setWidth = track.scrollWidth;
    if (!setWidth || !containerWidth) return;

    // Repeat the set until it comfortably exceeds the viewport, then duplicate
    // the whole lot once more — the animation shifts by exactly half.
    var repeats = Math.max(1, Math.ceil((containerWidth * 1.5) / setWidth));
    var copies = Math.min(repeats, MAX_CLONES);

    var frag = document.createDocumentFragment();
    for (var r = 1; r < copies; r++) {
      originals.forEach(function (node) {
        var c = node.cloneNode(true);
        c.dataset.plClone = 'true';
        c.setAttribute('aria-hidden', 'true');
        frag.appendChild(c);
      });
    }
    track.appendChild(frag);

    // The duplicate half that makes the loop seamless.
    var half = Array.prototype.slice.call(track.children);
    var frag2 = document.createDocumentFragment();
    half.forEach(function (node) {
      var c = node.cloneNode(true);
      c.dataset.plClone = 'true';
      c.setAttribute('aria-hidden', 'true');
      frag2.appendChild(c);
    });
    track.appendChild(frag2);

    var speed = parseFloat(root.getAttribute('data-speed'));
    if (!speed || isNaN(speed) || speed <= 0) speed = 55; // px per second

    var distance = track.scrollWidth / 2; // how far one loop travels
    var duration = distance / speed;

    track.style.setProperty('--pl-trust-duration', duration.toFixed(2) + 's');
    track.classList.add('pl-trust__track--running');
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pl-marquee]'), build);
  }

  // Rebuild on resize so the clone count still covers a wider viewport.
  var t = null;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(init, 250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Fonts landing late change the measured width, so re-measure once ready.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init).catch(function () {});
  }
})();
